
import { Component, Vue, Prop } from 'vue-property-decorator'
import { Form as ElForm, Input } from 'element-ui'
// 接口
import {editEmployee } from '@/api/employee'
@Component({
  name: 'Phone',
})
export default class extends Vue {
  @Prop() private dialogFormVisible!: any
  private validatePhone = (rule: any, value: any, callback: Function) => {
    const reg = /^(?:(?:\+|00)86)?1(?:(?:3[\d])|(?:4[5-79])|(?:5[0-35-9])|(?:6[5-7])|(?:7[0-8])|(?:8[\d])|(?:9[189]))\d{8}$/
    if (!value) {
      callback(new Error('请输入'))
    } else if (!reg.test(value)) {
      callback(new Error('号码格式错误'))
    } else {
      callback()
    }
  }
  rules = {
    newPhone: [{ validator: this.validatePhone, trigger: 'blur' }],
  }
  private form = {} as any
  private affirmPassword = ''
  handleSave() {
    (this.$refs.form as ElForm).validate(async (valid: boolean) => {
      if (valid) {
        const params = {
          id: 1,  
          phone: this.form.newPhone,
        }
        await editEmployee(params)
        this.$emit('handleclose')
        ;(this.$refs.form as ElForm).resetFields()
      } else {
        return false
      }
    })
  }
  handlePwdClose() {
    (this.$refs.form as ElForm).resetFields()
    this.$emit('handleclose')
  }
}
